var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitEntryIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.599,
    height: 54.809,
    viewBox: "0 0 43.599 54.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recruit_entry_icon4",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 12.45, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184183",
    "data-name": "\\uADF8\\uB8F9 184183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131942",
    "data-name": "\\uD328\\uC2A4 131942",
    d: "M26.475,0,3.841.633A3.95,3.95,0,0,0,0,4.692L1.087,43.635a3.95,3.95,0,0,0,4.059,3.838l22.634-.631a3.95,3.95,0,0,0,3.839-4.059L30.535,3.841A3.952,3.952,0,0,0,26.475,0Z",
    transform: "translate(0.314 0.313)",
    fill: "#ffbf17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131943",
    "data-name": "\\uD328\\uC2A4 131943",
    d: "M26.78,0,4.145.633A4.27,4.27,0,0,0,0,5.014L1.089,43.957A4.269,4.269,0,0,0,5.349,48.1l.12,0L28.1,47.468a4.269,4.269,0,0,0,4.142-4.381L31.161,4.144A4.275,4.275,0,0,0,26.78,0Zm1.305,46.841-22.634.632A3.622,3.622,0,0,1,1.714,43.94L.628,5A3.643,3.643,0,0,1,4.163,1.258L26.8.627l.1,0a3.639,3.639,0,0,1,3.634,3.537L31.621,43.1A3.642,3.642,0,0,1,28.086,46.843Z",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184184",
    "data-name": "\\uADF8\\uB8F9 184184",
    transform: "translate(4.145 0.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131944",
    "data-name": "\\uD328\\uC2A4 131944",
    d: "M5.984,2.437A5.583,5.583,0,0,0,1.214,0L0,.037.018.662,1.231.628A4.933,4.933,0,0,1,5.468,2.79L17.609,20.57a4.976,4.976,0,0,1,.155,5.356L6.628,44.438a4.942,4.942,0,0,1-4.115,2.4l-.142,0,.019.626.141,0A5.562,5.562,0,0,0,7.164,44.76L18.3,26.25a5.6,5.6,0,0,0-.174-6.032Z",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184185",
    "data-name": "\\uADF8\\uB8F9 184185",
    transform: "translate(13.551 0.096)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154165",
    "data-name": "\\uC0AC\\uAC01\\uD615 154165",
    width: 12.542,
    height: 0.625,
    transform: "translate(0 8.828) rotate(-44.74)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184186",
    "data-name": "\\uADF8\\uB8F9 184186",
    transform: "translate(14.396 38.736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154166",
    "data-name": "\\uC0AC\\uAC01\\uD615 154166",
    width: 0.625,
    height: 12.542,
    transform: "translate(0 0.468) rotate(-48.448)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184187",
    "data-name": "\\uADF8\\uB8F9 184187",
    transform: "translate(24.829 36.587)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154167",
    "data-name": "\\uC0AC\\uAC01\\uD615 154167",
    width: 4.458,
    height: 7.287,
    transform: "matrix(1, -0.028, 0.028, 1, 0, 0.124)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184190",
    "data-name": "\\uADF8\\uB8F9 184190",
    transform: "translate(25.515 30.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184188",
    "data-name": "\\uADF8\\uB8F9 184188",
    transform: "translate(0 0.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131945",
    "data-name": "\\uD328\\uC2A4 131945",
    d: "M.733,5.748a1.223,1.223,0,0,1,.239-.79,1.841,1.841,0,0,0,.333-1.135A1.846,1.846,0,0,0,.911,2.706a1.223,1.223,0,0,1-.284-.777,1.224,1.224,0,0,1,.239-.793A1.844,1.844,0,0,0,1.2,0L.573.017A1.229,1.229,0,0,1,.334.809,1.842,1.842,0,0,0,0,1.946,1.846,1.846,0,0,0,.4,3.063,1.223,1.223,0,0,1,.68,3.84a1.222,1.222,0,0,1-.239.79A1.922,1.922,0,0,0,.5,6.881a1.224,1.224,0,0,1,.283.775,1.22,1.22,0,0,1-.24.79A1.838,1.838,0,0,0,.214,9.581L.84,9.563a1.221,1.221,0,0,1,.239-.79,1.838,1.838,0,0,0,.333-1.135,1.84,1.84,0,0,0-.4-1.116A1.221,1.221,0,0,1,.733,5.748Z",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184189",
    "data-name": "\\uADF8\\uB8F9 184189",
    transform: "translate(1.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131946",
    "data-name": "\\uD328\\uC2A4 131946",
    d: "M.733,5.749a1.216,1.216,0,0,1,.24-.79,1.843,1.843,0,0,0,.333-1.136A1.853,1.853,0,0,0,.911,2.706a1.22,1.22,0,0,1-.284-.777,1.217,1.217,0,0,1,.239-.792A1.844,1.844,0,0,0,1.2,0L.573.017A1.222,1.222,0,0,1,.333.809,1.845,1.845,0,0,0,0,1.946,1.847,1.847,0,0,0,.4,3.064a1.221,1.221,0,0,1,.283.777,1.211,1.211,0,0,1-.239.79A1.924,1.924,0,0,0,.5,6.881a1.226,1.226,0,0,1,.283.775,1.219,1.219,0,0,1-.24.79A1.842,1.842,0,0,0,.214,9.581l.625-.017a1.227,1.227,0,0,1,.24-.79,1.84,1.84,0,0,0,.333-1.135,1.841,1.841,0,0,0-.4-1.115A1.219,1.219,0,0,1,.733,5.749Z",
    fill: "#111"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitEntryIcon4);
export default __webpack_public_path__ + "static/media/recruit_entry_icon4.4387ed3b5892f0f739e37588c2de409b.svg";
export { ForwardRef as ReactComponent };